import {faGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Text from 'components/Text/Text';
import {cutWord} from 'utils/helpers/cutWord';
import './TableRowAvatar.scss';

export interface ITableRowAvatarProps {
  logo: string | null;
  name: string;
  breweryName: string;
}

const TableRowAvatar = ({logo, name, breweryName}: ITableRowAvatarProps) => {
  return (
    <div data-testid="table-row-avatar" className="table-row-avatar__container">
      <div className="table-row-avatar__avatar">
        {logo && <img data-testid="table-row-avatar-image" src={logo} alt="beer logo" />}
        {!logo && (
          <div className="table-row-avatar__placeholder">
            <FontAwesomeIcon icon={faGlass} />
          </div>
        )}
      </div>
      <div className="table-row-avatar__wrapper">
        <div className="table-row-avatar__name">
          <Text data-testid="table-row-avatar-name" tag="h4">
            {cutWord(name, 24).toUpperCase()}
          </Text>
          <div className="table-row-avatar__wrapper">
            <Text data-testid="table-row-avatar-brewery" tag="h5">
              {cutWord(breweryName, 24)}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableRowAvatar;
